<script setup lang="ts">
import type { ComboboxProps } from "./combobox.types";
import { useComboboxSetup } from "./useCombobox";
import { VisuallyHiddenInput } from "components/VisuallyHidden";

defineOptions({ name: "ECombobox" });

const props = withDefaults(defineProps<ComboboxProps>(), {
  color: "neutral",
  variant: "subtle",
  size: "md",
  block: false,
  multiple: false,
  disabled: false,
  required: false,
  open: false,
  searchTerm: "",
  openOnFocus: true,
  resetSearchTermOnBlur: true,
  resetSearchTermOnSelect: true,
  filterDisabled: false,
});

const { state, isMultiple, classes } = useComboboxSetup({ props });
</script>

<template>
  <div
    part="base"
    :class="classes"
    class="e-combobox"
    :data-disabled="state.disabled?.value || undefined"
    :data-open="state.open?.value || undefined"
    :data-multiple="isMultiple || undefined"
  >
    <slot />

    <visually-hidden-input
      :name="state.name?.value"
      :value="state.modelValue?.value"
      :required="state.required?.value"
      :disabled="state.disabled?.value"
    />
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
